import React, { Component } from "react";
import {
  BoxSuccess,
  MnemoLoading,
  ModalHandler,
  MSection,
} from "components/misc";
import { COMPANY, CURRENT_EDITION_BANDO, LABEL_UNIVERSITY, ROUTES } from "const";
import {
  courseService,
  enrollmentEvaluationService,
  networkErrorHelper,
} from "libs";
import { Helmet } from "react-helmet";
import { withRouter } from "react-router-dom";
import {
  Row,
  Col,
  Button,
  AccordionHeader,
  AccordionBody,
  Container,
} from "design-react-kit";
import { MSearch } from "components/forms";
import { MTable } from "components/table";


class CourseBrowserPercorsiAbilitanti extends Component {
  _class1Ref = null;

  state = {
    loading: true,
    loadingError: false,
    currentRegion: "",
    currentCompetitionClass: "",
    bandiList: [],

    courseCompetitionClass: [],
    courseFiltered: [],

    payloadCompetitionClass: [],
    payloadRegion: [],

    filterRegionOpen: false,
    filterRegionApplied: false,

    filterCCOpen: false,
    filterCCApplied: false,

    toggleCourse60: false,
    toggleCourse30: false,
    toggleCourse30All2: false,
    toggleCourse36All4: false,
    toggleCourse60All5: false,

    currentAA: "2025",
    currentEdition: 1,
    currentCompany: "",
  };

  componentDidMount() {
    this.setState({ loading: true, loadingError: false });
    const { company } = this.props.match.params;
    const { currentAA } = this.state;

    //if company not empty and not in LABEL_UNIVERSITY, redirect to 404 page
    if ((company && !LABEL_UNIVERSITY[company]) || company === COMPANY.IUL) {
      this.props.history.push(ROUTES.PAGE_404);
    }

    const currentEdition = CURRENT_EDITION_BANDO[company] || 1;
    this.setState({ currentCompany: company, currentEdition });
    this.loadCompetitionClass(company);
    this.loadBandi(currentEdition, currentAA, company);
    this._class1Ref = React.createRef();
  }

  loadCompetitionClass(company) {
    courseService
      .listByCompetitionClass(
        "ABILITAZIONI60CFU_BANDO",
        this.state.currentAA,
        company
      )
      .then(({ data }) => {
        const { courseCompetitionClass } = data.payload;

        const payloadCompetitionClass = [];
        const payloadRegion = [];

        //fill payload for search filter
        courseCompetitionClass.forEach((item) => {
          const foundCC = payloadCompetitionClass.find(
            (el) => el.value === item.competitionClass
          );

          if (!foundCC) {
            payloadCompetitionClass.push({
              value: item.competitionClass,
              label: item.competitionClass + " - " + item.note,
            });
          }

          const foundRegion = payloadRegion.find(
            (el) => el.value === item.region
          );
          if (!foundRegion) {
            payloadRegion.push({
              value: item.region,
              label: item.region.toUpperCase(),
            });
          }

          // order payloadRegion based on value
          payloadRegion.sort((a, b) => {
            if (a.value < b.value) return -1;
            if (a.value > b.value) return 1;
            return 0;
          });

          // order payloadCompetitionClass based on value
          payloadCompetitionClass.sort((a, b) => {
            if (a.value < b.value) return -1;
            if (a.value > b.value) return 1;
            return 0;
          });
        });

        this.setState({
          courseCompetitionClass,
          courseFiltered: courseCompetitionClass,
          payloadCompetitionClass,
          payloadRegion,
          loading: false,
        });
      })
      .catch((error) => {
        console.log(error);
        if (!networkErrorHelper.is404(error)) {
          networkErrorHelper.notify(error);
          this.setState({ loadingError: true });
        }
      });
  }

  loadBandi(bandoedition, aa, company) {
    enrollmentEvaluationService
      .bandoEvaluationInfoList(bandoedition, aa, company)
      .then(({ data }) => {
        const bandiList = data.payload.bandiEvaluationInfo;
        this.setState({ bandiList });
      })
      .catch((error) => {
        console.log(error);
        if (!networkErrorHelper.is404(error)) {
          networkErrorHelper.notify(error);
          this.setState({ loadingError: true });
        }
      });
  }

  toggleCourse = (id) => {
    this.setState({
      ...this.defaultState,
      [`toggleCourse${id}`]: !this.state[`toggleCourse${id}`],
    });
  };

  toggleFilter = (id) => {
    this.setState({ filterRegionApplied: false, filterCCApplied: false });

    switch (id) {
      case "filterRegionOpen":
        this.setState({ filterCCOpen: false, filterRegionOpen: true });
        this.applyFilter("", "");
        break;

      case "filterCCOpen":
        this.setState({ filterCCOpen: true, filterRegionOpen: false });
        this.applyFilter("", "");
        break;
      default:
    }
  };

  toggleContingente = () => {
    const { bandiList } = this.state;

    if (!bandiList || bandiList.length === 0) {
      ModalHandler.show(
        null,
        "Contingente",
        "Nessun dato disponibile.",
        null,
        null,
        null,
        "Chiudi",
        false,
        true
      );
      return;
    }

    //group bandi by region
    const regions = {};
    bandiList.forEach((item) => {
      const r = item.region;
      if (!regions[r]) regions[r] = [];
      regions[r].push(item);
    });

    const tableConfig = {
      columns: [
        {
          id: "competitionClass",
          Header: "Classe",
          accessor: "competitionClass",
        },
        { id: "title", Header: "Denominazione", accessor: "title" },
        { id: "sitTotal", Header: "Posti", accessor: "sitTotal" },
      ],
    };

    const modalBody = Object.keys(regions)
      .sort()
      .map((region) => {
        const regionData = regions[region];

        //get region total seats
        const regionSeats = regionData.reduce((sum, item) => {
          return sum + item.sitTotal;
        }, 0);

        const tableData = [
          ...regionData,
          {
            id: `total-${region}`,
            competitionClass: "",
            title: <strong>Totale posti </strong>,
            sitTotal: <strong>{regionSeats}</strong>,
          },
        ];

        return (
          <>
            <div key={region}>
              <h3 className="text-center my-3">{region.toUpperCase()}</h3>
              <MTable tableConfig={tableConfig} tableData={tableData} />
            </div>
          </>
        );
      });

    ModalHandler.show(
      null,
      "Contingente",
      modalBody,
      null,
      null,
      null,
      "Chiudi",
      false,
      true
    );
  };

  openCourse(code) {
    window.open(`${ROUTES.COURSE_LANDINGPAGE}\\${code}`, "_blank");
  }

  changeCompetitionClass = (_, value) => {
    const newCompetitionClass = value ? value.value : "";
    this.applyFilter(newCompetitionClass, "");

    this.setState({ filterCCApplied: true });
  };

  changeRegion = (_, value) => {
    const newRegion = value ? value.value : "";
    this.applyFilter("", newRegion);
    this.setState({ filterRegionApplied: true });
  };

  filterReset() {
    this.applyFilter("", "");
    this.setState({
      filterRegionOpen: false,
      filterCCOpen: false,
      filterRegionApplied: false,
      filterCCApplied: false,
      courseFiltered: this.state.courseCompetitionClass,
    });
    if (this._class1Ref && this._class1Ref.current) {
      this._class1Ref.current.clearValue();
    }
  }

  applyFilter(competitionClass, region) {
    const { courseCompetitionClass } = this.state;
    let courseFiltered = courseCompetitionClass;

    if (courseFiltered.length === 0) {
      return;
    }

    if (competitionClass) {
      courseFiltered = courseFiltered.filter(
        (course) => course.competitionClass === competitionClass
      );
    }

    if (region) {
      courseFiltered = courseFiltered.filter(
        (course) => course.region === region
      );
    }

    this.setState({
      currentCompetitionClass: competitionClass,
      currentRegion: region,
      courseFiltered,
    });

    return courseFiltered;
  }

  getCourseCodes(course) {
    let c30all2 = course.code;
    let c30all4 = course.code;
    let c36all5 = course.code;
    let c60 = course.code;
    let c30 = course.code;

    // Prefix based on company
    let prefix = "";

    switch (course.instituteCompany) {
      case "unicamillus":
        prefix = "UM";
        break;
      case "reggio":
        prefix = "RC";
        break;
      case "unitelma":
        prefix = "UNT";
        break;
      default:
        prefix = "";
    }

    c30all2 = prefix + "ALL230CFU" + course.competitionClass + "_VC_25";
    c30all4 = prefix + "ALL430CFU" + course.competitionClass + "_VC_25";
    c36all5 = prefix + "ALL536CFU" + course.competitionClass + "_VC_25";
    c60 =
      prefix +
      "60ALL1" +
      course.competitionClass +
      course.region.toUpperCase().replace(/\s/g, '') +
      "_25_BANDO";
    c30 =
      prefix +
      "30ALL2" +
      course.competitionClass +
      course.region.toUpperCase().replace(/\s/g, '') +
      "_25_BANDO";

    return { c30all2, c30all4, c36all5, c60, c30 };
  }

  renderHeader() {
    const title = "Percorsi Abilitanti D.P.C.M. 4 AGOSTO 2023 a.a. 2025/2026";
    const { currentCompany } = this.state;

    let logo = "";
    let company = "";
    let textcontent = "";
    switch (currentCompany) {
      case COMPANY.UNICAMILLUS:
        logo = "/img/partners/Unicamillus_logo.png";
        company =
          "l'Università Unicamillus - Saint Camillus International University of Health Sciences";
        textcontent = "Per l’a.a. 2025/2026 il Ministero con Decreto n. 138 del 27-01-2026, ha autorizzato l'Università Unicamillus - Saint Camillus International University of Health Sciences all'attivazione dei Percorsi universitari di formazione iniziale dei docenti delle scuole secondarie di primo e secondo grado.";
        break;
      case COMPANY.REGGIO:
        logo = "/img/partners/Unidarc_logo.png";
        company =
          "l'Università per Stranieri “Dante Alighieri” di Reggio Calabria";
        textcontent = "Per l’a.a. 2025/2026 il Ministero con Decreto n. 138 del 27-01-2026, ha autorizzato l’Università per Stranieri “Dante Alighieri” di Reggio Calabria all'attivazione dei Percorsi universitari di formazione iniziale dei docenti delle scuole secondarie di primo e secondo grado.";
        break;
      case COMPANY.UNITELMA:
        logo = "/img/partners/Unitelma_logo.png";
        company =
          "l'Università UnitelmaSapienza - Università degli studi di Roma";
        textcontent = "A seguito della pubblicazione del decreto ministeriale di accreditamento nonché di autorizzazione dei posti di tutte le classi di concorso proposte, nelle more della pubblicazione del Bando di Partecipazione aggiornato nel rispetto di quanto delineato nel suddetto Decreto, sono avviate presso l'Università UnitelmaSapienza - Università degli studi di Roma, per l’anno accademico 2025/2026, le procedure di ammissione ai Percorsi universitari di formazione iniziale e abilitazione dei docenti della scuola secondaria di primo e secondo grado.";
        break;
      default:
        logo = "";
        company = "";
        textcontent = "";
    }

    return (
      <>
        <Helmet>
          <title>{title}</title>
          <meta property="og:title" content={title} />
        </Helmet>

        <div>
          <div className="w-100 text-center my-4">
            <img
              className="image-secondary-banner w-50"
              src={logo}
              alt={company}
            />
          </div>
        </div>
        <MSection className="mb-3">
          <div>
            <h1>{title}</h1>
            <p>
              {textcontent}
            </p>
          </div>
        </MSection>
        <div className="my-3">
          <Button
            color="primary bg-dark"
            className="w-100 py-3"
            onClick={this.toggleContingente}
          >
            Mostra contingente
          </Button>
        </div>
      </>
    );
  }

  renderAccordion() {
    const {
      toggleCourse60,
      toggleCourse30,
      toggleCourse30All2,
      toggleCourse30All4,
      toggleCourse36All5,
      currentCompany,
    } = this.state;

    return (
      <>
        <MSection className="mb-3">
          <h2>Le tipologie di Percorsi attivati a numero programmato</h2>
          <p>
            <b>
              A tali percorsi possono accedere un numero massimo di studenti
              definito annualmente dal Ministero, l'accesso è quindi a numero
              programmato (numero chiuso).
            </b>
          </p>

          <AccordionHeader
            active={toggleCourse60}
            onToggle={() => this.toggleCourse("60")}
          >
            <h6>
              <b>Corsi abilitanti 60 CFU/CFA:</b> destinati ai Laureati, Laureandi
              e Docenti di percorsi di istruzione e formazione professionale
              regionali (A)
            </h6>
          </AccordionHeader>
          <AccordionBody active={toggleCourse60}>
            <p>
              <b>
                Percorso universitario abilitante di formazione iniziale di 60
                CFU/CFA{" "}
              </b>
              (All. 1 DPCM 4 agosto 2023): percorso ordinario riservato ai
              laureati (in possesso dei titoli di studio di cui all'art. 5, commi
              1 e 2, del decreto legislativo del 13 aprile 2017 n.59), agli
              iscritti ai corsi di laurea magistrale (purché abbiano conseguito
              180 CFU e che per il conseguimento del titolo idoneo all'accesso
              devono conseguire ancora un numero inferiore a 60 CFU) e ai Docenti
              di percorsi di istruzione e formazione professionale regionali.
            </p>
          </AccordionBody>

          <AccordionHeader
            active={toggleCourse30}
            onToggle={() => this.toggleCourse("30")}
          >
            <h6>
              <b>Corsi abilitanti 30 CFU/CFA:</b> destinati a chi ha svolto tre
              anni di servizio d'insegnamento negli ultimi 5, di cui almeno 1
              nella specifica classe di concorso (B)
            </h6>
          </AccordionHeader>
          <AccordionBody active={toggleCourse30}>
            <p>
              <b>
                Percorso universitario abilitante di formazione iniziale di 30
                CFU/CFA
              </b>{" "}
              (All. 2 DPCM 4 agosto 2023): percorsi preordinati all'acquisizione
              di 30 CFU, di cui all'art. 2 ter, comma 4 bis, del decreto
              legislativo 13 aprile 2017, n. 59 per coloro che hanno svolto
              servizio presso le istituzioni scolastiche statali o presso le
              scuole paritarie per almeno tre anni, anche non continuativi, di cui
              almeno uno nella specifica classe di concorso per la quale scelgono
              di conseguire l'abilitazione, nei cinque anni precedenti, valutati
              ai sensi dell'articolo 11, comma 14, della legge 3 maggio 1999, n.
              124, nonché per coloro che hanno sostenuto la prova concorsuale
              relativa alla procedura straordinaria di cui all'articolo 59, comma
              9-bis, del decreto-legge 25 maggio 2021, n. 73, convertito, con
              modificazioni, dalla legge 23 luglio 2021, n. 106.
            </p>
          </AccordionBody>

          <h2>Percorsi di completamento attivati a numero non programmato</h2>
          <p>
            {" "}
            <b>
              SOLO per i vincitori di concorso. Tali percorsi non sono a numero
              programmato, l'accesso è quindi libero.
            </b>
          </p>

          <AccordionHeader
            active={toggleCourse30All2}
            onToggle={() => this.toggleCourse("30All2")}
          >
            <h6>
              <b>Percorso 30 CFU/CFA:</b> destinato ai vincitori del concorso che
              abbiano tre anni di servizio (C)
            </h6>
          </AccordionHeader>
          <AccordionBody active={toggleCourse30All2}>
            <p>
              <b>Percorso preordinato all'acquisizione dei 30 CFU/CFA </b>ai sensi
              dell'articolo 13, comma 2, del decreto legislativo 13 aprile 2017 n.
              59 (ALL. 2 DPCM 4 agosto 2023): destinato ai vincitori del concorso
              che abbiano tre anni di servizio.
            </p>
          </AccordionBody>

          <AccordionHeader
            active={toggleCourse30All4}
            onToggle={() => this.toggleCourse("30All4")}
          >
            <h6>
              <b>Percorso 30 CFU/CFA: </b> destinato ai vincitori del concorso a
              cui hanno avuto accesso con il requisito dei 30 CFU/CFA non
              abilitanti, propedeutici al concorso (D)
            </h6>
          </AccordionHeader>
          <AccordionBody active={toggleCourse30All4}>
            <p>
              <b>Percorso preordinato all'acquisizione dei 30 CFU/CFA </b>di
              completamento, di cui all'articolo 18 bis comma 3, secondo periodo,
              del decreto legislativo 13 aprile 2017 n. 59, destinato ai vincitori
              del concorso di cui al comma 1 dello stesso articolo (ALL.4 DPCM 4
              agosto 2023).
            </p>
          </AccordionBody>

          {/** 36ALL5 only for unicamillus */}
          {currentCompany === COMPANY.UNICAMILLUS && (
            <>
              <AccordionHeader
                active={toggleCourse36All5}
                onToggle={() => this.toggleCourse("36All5")}
              >
                <h6>
                  <b>Percorso 36 CFU/CFA:</b> destinato ai vincitori del concorso
                  a cui hanno avuto accesso con il requisito dei 24 CFU/CFA
                  conseguiti entro il 31 ottobre 2022 (E)
                </h6>
              </AccordionHeader>
              <AccordionBody active={toggleCourse36All5}>
                <p>
                  <b>Percorso preordinato all'acquisizione dei 36 CFU/CFA </b>
                  di completamento, di cui all'articolo 18 bis, comma 4, secondo
                  periodo, del decreto legislativo 13 aprile 2017 n. 59 (ALL. 5
                  DPCM 4 agosto 2023): destinato a coloro i quali, entro il 31
                  ottobre 2022, abbiano conseguito i 24 CFU/CFA.
                </p>
              </AccordionBody>
            </>
          )}
        </MSection>
      </>
    );
  }

  renderFilter() {
    const {
      payloadCompetitionClass,
      payloadRegion,
      filterRegionOpen,
      filterCCOpen,
    } = this.state;

    return (
      <>
        <MSection className="mb-3">
          <Row>
            <Col size="12" md="6">
              <AccordionHeader
                active={filterCCOpen}
                onToggle={() => this.toggleFilter("filterCCOpen")}
              >
                <h6>Ricerca per Classe di Concorso</h6>
              </AccordionHeader>
              <AccordionBody active={filterCCOpen}>
                <MSearch
                  key="class-select"
                  field="class-select"
                  id="class-select"
                  name="class-select"
                  placeHolder="Inserisci o seleziona classe"
                  payload={payloadCompetitionClass}
                  onChange={this.changeCompetitionClass}
                  ref={this._class1Ref}
                />
                <Button
                  outline
                  className="float-right mt-2"
                  onClick={(e) => this.filterReset()}
                >
                  Cancella filtri
                </Button>
              </AccordionBody>
            </Col>
            <Col size="12" md="6">
              <AccordionHeader
                active={filterRegionOpen}
                onToggle={() => this.toggleFilter("filterRegionOpen")}
              >
                <h6>Ricerca per Regione</h6>
              </AccordionHeader>
              <AccordionBody active={filterRegionOpen}>
                <MSearch
                  key="region2-select"
                  field="region2-select"
                  id="region2-select"
                  name="region2-select"
                  placeHolder="Inserisci o seleziona regione"
                  payload={payloadRegion}
                  onChange={this.changeRegion}
                />
                <Button
                  outline
                  className="float-right mt-2"
                  onClick={(e) => this.filterReset()}
                >
                  Cancella filtri
                </Button>
              </AccordionBody>
            </Col>
          </Row>
        </MSection>
      </>
    );
  }

  renderCourseActions(course) {
    const { c30all2, c30all4, c36all5, c30, c60 } = this.getCourseCodes(course);
    const isUnicamillus = course.instituteCompany === COMPANY.UNICAMILLUS;

    return (
      <div className="d-flex flex-wrap align-items-center">
        <Button
          color="secondary"
          size="sm"
          className="mr-1 mb-2"
          onClick={() =>
            window.open(`${ROUTES.COURSE_LANDINGPAGE_FULL}/${c60}`, "_blank")
          }
        >
          60 CFU All.1<br />num. progr. (A)
        </Button>
        <Button
          color="secondary"
          size="sm"
          className="mr-1 mb-2"
          onClick={() =>
            window.open(`${ROUTES.COURSE_LANDINGPAGE_FULL}/${c30}`, "_blank")
          }
        >
          30 CFU All.2<br />num. progr. (B)
        </Button>
        <Button
          outline
          color="secondary"
          size="sm"
          className="mr-1 mb-2"
          onClick={() =>
            window.open(`${ROUTES.COURSE_LANDINGPAGE_FULL}/${c30all2}`, "_blank")
          }
        >
          30 CFU All.2 (C)<br />Vincitore Concorso
        </Button>
        <Button
          outline
          color="secondary"
          size="sm"
          className="mr-1 mb-2"
          onClick={() =>
            window.open(`${ROUTES.COURSE_LANDINGPAGE_FULL}/${c30all4}`, "_blank")
          }
        >
          30 CFU All.4 (D)<br />Vincitore Concorso
        </Button>
        {isUnicamillus && (
          <Button
            outline
            color="secondary"
            size="sm"
            className="mr-1 mb-2"
            onClick={() =>
              window.open(
                `${ROUTES.COURSE_LANDINGPAGE_FULL}/${c36all5}`,
                "_blank"
              )
            }
          >
            36 CFU All.5 (E)<br />Vincitore Concorso
          </Button>
        )}
      </div>
    );
  }

  renderGroup(title, items, key) {

    return (
      <div key={`group-${key}`}>
        <h6 className="text-green">{title}</h6>
        {items}
      </div>
    );
  }

  renderCourseList() {
    const { courseFiltered, filterCCOpen, filterCCApplied } = this.state;

    if (!courseFiltered || courseFiltered.length === 0) {
      return (
        <BoxSuccess>La ricerca non ha prodotto alcun risultato.</BoxSuccess>
      );
    }

    const tableConfig = {
      columns: [
        { id: "region", Header: "Regione", accessor: "region" },
        { id: "competitionClass", Header: "Classe", accessor: "competitionClass" },
        { id: "note", Header: "Denominazione", accessor: "note" },
        { id: "actions", Header: "Iscrizioni", accessor: "actions", className: "w-50" },
      ],
    };

    let courseList = [];
    let currentList = [];
    let currentTableData = [];

    //if CC filter is active, group by region, else group by CC
    const isFilteredByCC = filterCCOpen && filterCCApplied;

    let groupKey = isFilteredByCC
      ? courseFiltered[0].region
      : courseFiltered[0].competitionClass;

    courseFiltered.forEach((course, i) => {
      const compareKey = isFilteredByCC
        ? course.region
        : course.competitionClass;

      if (compareKey !== groupKey) {
        const prevCourse = courseFiltered[i - 1];
        const title = isFilteredByCC
          ? `${groupKey.toUpperCase()} - ${prevCourse.competitionClass} - ${prevCourse.note
          }`
          : `${groupKey} - ${prevCourse.note}`;

        courseList.push(
          this.renderGroup(
            title,
            <MTable tableConfig={tableConfig} tableData={currentTableData} showHeader={false} />,
            `${groupKey}-${i}`
          )
        );
        currentList = [];
        currentTableData = [];
        groupKey = compareKey;
      }

      currentList.push(course);
      currentTableData.push({
        id: course.id,
        region: course.region ? course.region.toUpperCase() : "",
        competitionClass: course.competitionClass,
        note: course.note,
        actions: this.renderCourseActions(course),
      });
    });


    if (currentList.length > 0) {
      const lastCourse = courseFiltered[courseFiltered.length - 1];
      const title = isFilteredByCC
        ? `${groupKey.toUpperCase()} - ${lastCourse.competitionClass} - ${lastCourse.note}`
        : `${groupKey} - ${lastCourse.note}`;

      courseList.push(
        this.renderGroup(
          title,
          <MTable tableConfig={tableConfig} tableData={currentTableData} showHeader={false} />,
          `${groupKey}-${courseFiltered.length + 1}`
        )
      );
    }

    return <>{courseList}</>;
  }

  renderCosti() {
    let c60 = "";
    let c30 = "";
    let c3036 = "";

    switch (this.state.currentCompany) {
      case COMPANY.UNICAMILLUS:
        c60 =
          "€ 2.380 + € 16 (marca da bollo) rateizzabili fino a n. 3 versamenti.";
        c30 =
          "€ 1.880 + € 16 (marca da bollo) rateizzabili fino a n. 3 versamenti.";
        c3036 =
          "Il Costo dei Corsi è di € 1.880 + € 16 (marca da bollo) rateizzabili in n. 3 versamenti.";
        break;

      case COMPANY.REGGIO:
        c60 = (
          <p>
            a partire da € 2.380* + € 16 (marca da bollo) rateizzabili fino a n. 3 versamenti. <br />(*) Per la classe di concorso <b>B022</b> prezzo agevolato di € 2.380 + € 16 (marca da bollo)
          </p>

        );
        c30 = (
          <p>
            a partire da € 1.880* + € 16 (marca da bollo) rateizzabili fino a n. 3 versamenti.<br />(*) Per la classe di concorso <b>B022</b> prezzo agevolato di € 1.880 + € 16 (marca da bollo)
          </p>

        );
        c3036 = (
          <ul>
            <li>
              Il Costo dei Corsi è di € 1.900 + € 16 (marca da bollo) rateizzabili in n. 3 versamenti.
            </li>
          </ul>
        );

        break;

      case COMPANY.UNITELMA:
        c60 =
          "€ 2.400 + € 16 (marca da bollo) rateizzabili fino a n. 3 versamenti.";
        c30 =
          "€ 1.900 + € 16 (marca da bollo) rateizzabili fino a n. 3 versamenti.";
        c3036 =
          "Il Costo dei Corsi è di € 1.900 + € 16 (marca da bollo) rateizzabili in n. 3 versamenti.";
        break;

      default:
        c60 = "";
        c30 = "";
        c3036 = "";
    }

    return (
      <>
        <h2>Costi</h2>
        <p>
          <b>PERCORSO 60 CFU ALL. 1 (destinato ai Laureati e Laureandi):</b>
        </p>
        <ul>
          <li>
            contributo pari a € 100,00 per la presentazione della domanda di
            ammissione;
          </li>
          <li>{c60}</li>
        </ul>
        come previsto dal DPCM 4 Agosto 2023 per accedere alla prova
        finale è previsto un versamento di € 150 (Centocinquanta/00).

        <hr />
        <p>
          <b>
            PERCORSO 30 CFU ALL.2 (destinato a chi ha svolto tre anni di
            servizio d'insegnamento)
          </b>
        </p>
        <ul>
          <li>
            contributo pari a € 100,00 per la presentazione della domanda di
            ammissione;
          </li>
          <li>{c30}</li>
        </ul>
        <p>come previsto dal DPCM 4 Agosto 2023 per accedere alla prova
          finale è previsto un versamento di € 150 (Centocinquanta/00).
        </p>
        <hr />
        <p>
          <b>PERCORSI VINCITORI DI CONCORSO</b><br />
          {c3036} <br />
          come previsto dal DPCM 4 Agosto 2023 per accedere alla prova
          finale é previsto un versamento di € 150 (Centocinquanta/00).
        </p>
      </>
    );
  }

  render() {
    const { loading, loadingError } = this.state;

    let courseListSection = "";
    let filterSection = "";

    if (!loading && !loadingError) {
      courseListSection = this.renderCourseList();
      filterSection = this.renderFilter();
    }

    let scadenza = '';
    let calendario = '';

    switch (this.state.currentCompany) {
      case COMPANY.UNICAMILLUS:
        scadenza = 'Giovedì 26 Febbraio ore 15:00 ';
        calendario = 'https://www.formazionedocenti.it/files/corsi/UM306036/calendariounicamillus.pdf';
        break;
      case COMPANY.REGGIO:
        scadenza = 'Mercoledì 11 Marzo ore 12:00';
        calendario = 'https://www.formazionedocenti.it/files/corsi/RC3060/calendarioreggio.pdf';
        break;
      case COMPANY.UNITELMA:
        scadenza = 'Lunedì 2 Marzo ore 15:00';
        calendario = 'https://www.formazionedocenti.it/files/corsi/UNT3060/calendariounitelma.pdf';
        break;
      default:
        scadenza = '';
        calendario = "";
    }

    return (
      <section className="my-4">
        <style>
          {`
          .modal-dialog-centered {
            align-items: flex-start !important;
            padding-top: 150px !important; 
          }
          .modal-body {
          max-height: 60vh;
          overflow-y: auto;
          }
        `}
        </style>

        {this.renderHeader()}
        {this.renderAccordion()}

        <hr />

        {loading ? (
          <MnemoLoading />
        ) : (
          <>
            <Container>
              {filterSection}
              <MSection className="mb-3">
                <Row>
                  <Col size="12">{courseListSection}</Col>
                </Row>
              </MSection>
            </Container>
          </>
        )}
        <hr />
        <h2>Attività Formativa</h2>
        <p>
          <b>Lezioni:</b> in presenza nella Regione di attivazione del corso
          presso la sede accreditata e on-line in modalità telematica sincrona,
          ad eccezione dei tirocini e dei laboratori, con una percentuale
          massima del 50% del totale.
        </p>
        <p>
          <b>Prova finale (prova scritta + lezione simulata):</b> al termine
          delle attività didattiche ed entro il 30 Giugno 2026 (salvo diverse
          disposizioni Ministeriali)
        </p>
        <p>
          <b>Ammissione alla prova finale:</b> è necessaria una percentuale
          minima di presenza alle attività formative pari al 70% per ogni
          attività formativa.
        </p>
        <p>
          <b>Sedi Esami finali:</b> in una o più sedi nella Regione dove è stato
          accreditato il corso.
        </p>
        <p>
          <b>Calendario attività: </b> <a href={calendario} target="_blank" rel="noopener noreferrer"> (clicca qui per scaricare il Calendario Attività Formative)</a>
        </p>

        <hr />
        {this.renderCosti()}
        <hr />
        <p>
          <b>Scadenza presentazione domanda di ammissione:</b> entro {scadenza}
        </p>
        <hr />
        <p>
          E-mail:{" "}
          <a href="mailto:abilitazione@formazionedocenti.it">
            abilitazione@formazionedocenti.it
          </a>
        </p>
      </section>
    );
  }
}

export default withRouter(CourseBrowserPercorsiAbilitanti);
